import * as React from 'react';

export const AppDataContext = React.createContext({
    chain: "avalanche",
    updateChain: () => { },
});